import { render, staticRenderFns } from "./CreateChannelModal.vue?vue&type=template&id=23c49a41&"
import script from "./CreateChannelModal.vue?vue&type=script&lang=ts&"
export * from "./CreateChannelModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateChannelModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateChannelModal.vue"
export default component.exports